import React, { useEffect, useState, useCallback, useRef } from 'react';
import { HiOutlineHome, HiOutlinePencil, HiOutlineSearch, HiOutlineUser, HiOutlinePlus, HiOutlineTrash, HiOutlineTruck } from 'react-icons/hi';
import AppLayout from '../../components/layout/AppLayout';
import Button from '../../components/ui/Button';
import Modal from '../../components/ui/Modal';
import StatCard from '../../components/ui/StatCard';
import FormInput from '../../components/forms/FormInput';
import FormSelect from '../../components/forms/FormSelect';
import { getApartments, updateApartment, addVehicle, removeVehicle, uploadTenantDoc } from '../../api/gasReadings';

const STORAGE_BASE = (process.env.REACT_APP_API_URL || 'http://tgcaoa-backend.test/api').replace(/\/api$/, '') + '/storage/';
const storageUrl = (path) => path ? STORAGE_BASE + path : null;

const vehicleTypeOptions = [
  { value: '', label: 'Select type' },
  { value: 'Car', label: 'Car' },
  { value: 'Scooter', label: 'Scooter' },
  { value: 'Motorcycle', label: 'Motorcycle' },
  { value: 'SUV', label: 'SUV' },
  { value: 'Van', label: 'Van' },
  { value: 'Other', label: 'Other' },
];

const COUNTRY_CODES = [
  { code: '+91',  flag: '🇮🇳', name: 'India' },
  { code: '+1',   flag: '🇺🇸', name: 'USA / Canada' },
  { code: '+44',  flag: '🇬🇧', name: 'United Kingdom' },
  { code: '+971', flag: '🇦🇪', name: 'UAE' },
  { code: '+966', flag: '🇸🇦', name: 'Saudi Arabia' },
  { code: '+974', flag: '🇶🇦', name: 'Qatar' },
  { code: '+965', flag: '🇰🇼', name: 'Kuwait' },
  { code: '+973', flag: '🇧🇭', name: 'Bahrain' },
  { code: '+968', flag: '🇴🇲', name: 'Oman' },
  { code: '+65',  flag: '🇸🇬', name: 'Singapore' },
  { code: '+61',  flag: '🇦🇺', name: 'Australia' },
  { code: '+64',  flag: '🇳🇿', name: 'New Zealand' },
  { code: '+49',  flag: '🇩🇪', name: 'Germany' },
  { code: '+33',  flag: '🇫🇷', name: 'France' },
  { code: '+39',  flag: '🇮🇹', name: 'Italy' },
  { code: '+34',  flag: '🇪🇸', name: 'Spain' },
  { code: '+31',  flag: '🇳🇱', name: 'Netherlands' },
  { code: '+32',  flag: '🇧🇪', name: 'Belgium' },
  { code: '+41',  flag: '🇨🇭', name: 'Switzerland' },
  { code: '+43',  flag: '🇦🇹', name: 'Austria' },
  { code: '+46',  flag: '🇸🇪', name: 'Sweden' },
  { code: '+47',  flag: '🇳🇴', name: 'Norway' },
  { code: '+45',  flag: '🇩🇰', name: 'Denmark' },
  { code: '+358', flag: '🇫🇮', name: 'Finland' },
  { code: '+353', flag: '🇮🇪', name: 'Ireland' },
  { code: '+351', flag: '🇵🇹', name: 'Portugal' },
  { code: '+30',  flag: '🇬🇷', name: 'Greece' },
  { code: '+48',  flag: '🇵🇱', name: 'Poland' },
  { code: '+420', flag: '🇨🇿', name: 'Czech Republic' },
  { code: '+36',  flag: '🇭🇺', name: 'Hungary' },
  { code: '+40',  flag: '🇷🇴', name: 'Romania' },
  { code: '+359', flag: '🇧🇬', name: 'Bulgaria' },
  { code: '+385', flag: '🇭🇷', name: 'Croatia' },
  { code: '+381', flag: '🇷🇸', name: 'Serbia' },
  { code: '+386', flag: '🇸🇮', name: 'Slovenia' },
  { code: '+421', flag: '🇸🇰', name: 'Slovakia' },
  { code: '+372', flag: '🇪🇪', name: 'Estonia' },
  { code: '+371', flag: '🇱🇻', name: 'Latvia' },
  { code: '+370', flag: '🇱🇹', name: 'Lithuania' },
  { code: '+7',   flag: '🇷🇺', name: 'Russia' },
  { code: '+380', flag: '🇺🇦', name: 'Ukraine' },
  { code: '+375', flag: '🇧🇾', name: 'Belarus' },
  { code: '+90',  flag: '🇹🇷', name: 'Turkey' },
  { code: '+972', flag: '🇮🇱', name: 'Israel' },
  { code: '+962', flag: '🇯🇴', name: 'Jordan' },
  { code: '+961', flag: '🇱🇧', name: 'Lebanon' },
  { code: '+963', flag: '🇸🇾', name: 'Syria' },
  { code: '+964', flag: '🇮🇶', name: 'Iraq' },
  { code: '+98',  flag: '🇮🇷', name: 'Iran' },
  { code: '+93',  flag: '🇦🇫', name: 'Afghanistan' },
  { code: '+92',  flag: '🇵🇰', name: 'Pakistan' },
  { code: '+880', flag: '🇧🇩', name: 'Bangladesh' },
  { code: '+94',  flag: '🇱🇰', name: 'Sri Lanka' },
  { code: '+977', flag: '🇳🇵', name: 'Nepal' },
  { code: '+975', flag: '🇧🇹', name: 'Bhutan' },
  { code: '+960', flag: '🇲🇻', name: 'Maldives' },
  { code: '+95',  flag: '🇲🇲', name: 'Myanmar' },
  { code: '+66',  flag: '🇹🇭', name: 'Thailand' },
  { code: '+84',  flag: '🇻🇳', name: 'Vietnam' },
  { code: '+855', flag: '🇰🇭', name: 'Cambodia' },
  { code: '+856', flag: '🇱🇦', name: 'Laos' },
  { code: '+62',  flag: '🇮🇩', name: 'Indonesia' },
  { code: '+63',  flag: '🇵🇭', name: 'Philippines' },
  { code: '+670', flag: '🇹🇱', name: 'Timor-Leste' },
  { code: '+673', flag: '🇧🇳', name: 'Brunei' },
  { code: '+856', flag: '🇱🇦', name: 'Laos' },
  { code: '+81',  flag: '🇯🇵', name: 'Japan' },
  { code: '+82',  flag: '🇰🇷', name: 'South Korea' },
  { code: '+850', flag: '🇰🇵', name: 'North Korea' },
  { code: '+86',  flag: '🇨🇳', name: 'China' },
  { code: '+852', flag: '🇭🇰', name: 'Hong Kong' },
  { code: '+853', flag: '🇲🇴', name: 'Macau' },
  { code: '+886', flag: '🇹🇼', name: 'Taiwan' },
  { code: '+976', flag: '🇲🇳', name: 'Mongolia' },
  { code: '+998', flag: '🇺🇿', name: 'Uzbekistan' },
  { code: '+993', flag: '🇹🇲', name: 'Turkmenistan' },
  { code: '+992', flag: '🇹🇯', name: 'Tajikistan' },
  { code: '+996', flag: '🇰🇬', name: 'Kyrgyzstan' },
  { code: '+7',   flag: '🇰🇿', name: 'Kazakhstan' },
  { code: '+994', flag: '🇦🇿', name: 'Azerbaijan' },
  { code: '+995', flag: '🇬🇪', name: 'Georgia' },
  { code: '+374', flag: '🇦🇲', name: 'Armenia' },
  { code: '+20',  flag: '🇪🇬', name: 'Egypt' },
  { code: '+212', flag: '🇲🇦', name: 'Morocco' },
  { code: '+216', flag: '🇹🇳', name: 'Tunisia' },
  { code: '+213', flag: '🇩🇿', name: 'Algeria' },
  { code: '+218', flag: '🇱🇾', name: 'Libya' },
  { code: '+249', flag: '🇸🇩', name: 'Sudan' },
  { code: '+251', flag: '🇪🇹', name: 'Ethiopia' },
  { code: '+254', flag: '🇰🇪', name: 'Kenya' },
  { code: '+255', flag: '🇹🇿', name: 'Tanzania' },
  { code: '+256', flag: '🇺🇬', name: 'Uganda' },
  { code: '+250', flag: '🇷🇼', name: 'Rwanda' },
  { code: '+233', flag: '🇬🇭', name: 'Ghana' },
  { code: '+234', flag: '🇳🇬', name: 'Nigeria' },
  { code: '+237', flag: '🇨🇲', name: 'Cameroon' },
  { code: '+225', flag: '🇨🇮', name: "Côte d'Ivoire" },
  { code: '+221', flag: '🇸🇳', name: 'Senegal' },
  { code: '+223', flag: '🇲🇱', name: 'Mali' },
  { code: '+226', flag: '🇧🇫', name: 'Burkina Faso' },
  { code: '+227', flag: '🇳🇪', name: 'Niger' },
  { code: '+228', flag: '🇹🇬', name: 'Togo' },
  { code: '+229', flag: '🇧🇯', name: 'Benin' },
  { code: '+224', flag: '🇬🇳', name: 'Guinea' },
  { code: '+245', flag: '🇬🇼', name: 'Guinea-Bissau' },
  { code: '+232', flag: '🇸🇱', name: 'Sierra Leone' },
  { code: '+231', flag: '🇱🇷', name: 'Liberia' },
  { code: '+220', flag: '🇬🇲', name: 'Gambia' },
  { code: '+238', flag: '🇨🇻', name: 'Cape Verde' },
  { code: '+240', flag: '🇬🇶', name: 'Equatorial Guinea' },
  { code: '+241', flag: '🇬🇦', name: 'Gabon' },
  { code: '+242', flag: '🇨🇬', name: 'Congo' },
  { code: '+243', flag: '🇨🇩', name: 'DR Congo' },
  { code: '+236', flag: '🇨🇫', name: 'Central African Republic' },
  { code: '+235', flag: '🇹🇩', name: 'Chad' },
  { code: '+239', flag: '🇸🇹', name: 'São Tomé & Príncipe' },
  { code: '+244', flag: '🇦🇴', name: 'Angola' },
  { code: '+260', flag: '🇿🇲', name: 'Zambia' },
  { code: '+263', flag: '🇿🇼', name: 'Zimbabwe' },
  { code: '+265', flag: '🇲🇼', name: 'Malawi' },
  { code: '+258', flag: '🇲🇿', name: 'Mozambique' },
  { code: '+261', flag: '🇲🇬', name: 'Madagascar' },
  { code: '+230', flag: '🇲🇺', name: 'Mauritius' },
  { code: '+248', flag: '🇸🇨', name: 'Seychelles' },
  { code: '+269', flag: '🇰🇲', name: 'Comoros' },
  { code: '+252', flag: '🇸🇴', name: 'Somalia' },
  { code: '+253', flag: '🇩🇯', name: 'Djibouti' },
  { code: '+291', flag: '🇪🇷', name: 'Eritrea' },
  { code: '+266', flag: '🇱🇸', name: 'Lesotho' },
  { code: '+268', flag: '🇸🇿', name: 'Eswatini' },
  { code: '+267', flag: '🇧🇼', name: 'Botswana' },
  { code: '+264', flag: '🇳🇦', name: 'Namibia' },
  { code: '+27',  flag: '🇿🇦', name: 'South Africa' },
  { code: '+52',  flag: '🇲🇽', name: 'Mexico' },
  { code: '+55',  flag: '🇧🇷', name: 'Brazil' },
  { code: '+54',  flag: '🇦🇷', name: 'Argentina' },
  { code: '+56',  flag: '🇨🇱', name: 'Chile' },
  { code: '+57',  flag: '🇨🇴', name: 'Colombia' },
  { code: '+51',  flag: '🇵🇪', name: 'Peru' },
  { code: '+58',  flag: '🇻🇪', name: 'Venezuela' },
  { code: '+593', flag: '🇪🇨', name: 'Ecuador' },
  { code: '+591', flag: '🇧🇴', name: 'Bolivia' },
  { code: '+595', flag: '🇵🇾', name: 'Paraguay' },
  { code: '+598', flag: '🇺🇾', name: 'Uruguay' },
  { code: '+592', flag: '🇬🇾', name: 'Guyana' },
  { code: '+597', flag: '🇸🇷', name: 'Suriname' },
  { code: '+53',  flag: '🇨🇺', name: 'Cuba' },
  { code: '+1876',flag: '🇯🇲', name: 'Jamaica' },
  { code: '+1868',flag: '🇹🇹', name: 'Trinidad & Tobago' },
  { code: '+1246',flag: '🇧🇧', name: 'Barbados' },
  { code: '+1242',flag: '🇧🇸', name: 'Bahamas' },
  { code: '+509', flag: '🇭🇹', name: 'Haiti' },
  { code: '+1809',flag: '🇩🇴', name: 'Dominican Republic' },
  { code: '+502', flag: '🇬🇹', name: 'Guatemala' },
  { code: '+503', flag: '🇸🇻', name: 'El Salvador' },
  { code: '+504', flag: '🇭🇳', name: 'Honduras' },
  { code: '+505', flag: '🇳🇮', name: 'Nicaragua' },
  { code: '+506', flag: '🇨🇷', name: 'Costa Rica' },
  { code: '+507', flag: '🇵🇦', name: 'Panama' },
  { code: '+675', flag: '🇵🇬', name: 'Papua New Guinea' },
  { code: '+677', flag: '🇸🇧', name: 'Solomon Islands' },
  { code: '+678', flag: '🇻🇺', name: 'Vanuatu' },
  { code: '+679', flag: '🇫🇯', name: 'Fiji' },
  { code: '+685', flag: '🇼🇸', name: 'Samoa' },
  { code: '+676', flag: '🇹🇴', name: 'Tonga' },
  { code: '+686', flag: '🇰🇮', name: 'Kiribati' },
  { code: '+691', flag: '🇫🇲', name: 'Micronesia' },
  { code: '+692', flag: '🇲🇭', name: 'Marshall Islands' },
  { code: '+680', flag: '🇵🇼', name: 'Palau' },
  { code: '+674', flag: '🇳🇷', name: 'Nauru' },
  { code: '+688', flag: '🇹🇻', name: 'Tuvalu' },
];

function splitPhone(phone) {
  if (!phone) return { countryCode: '+91', number: '' };
  const match = COUNTRY_CODES.find(c => phone.startsWith(c.code));
  if (match) return { countryCode: match.code, number: phone.slice(match.code.length).trim() };
  return { countryCode: '+91', number: phone };
}

function formatPhone(phone) {
  if (!phone) return null;
  const match = COUNTRY_CODES.find(c => phone.startsWith(c.code));
  if (match) return `${match.flag} ${match.code} ${phone.slice(match.code.length).trim()}`;
  return `🇮🇳 +91 ${phone}`;
}

function CountryCodePicker({ value, onChange }) {
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const selected = COUNTRY_CODES.find(c => c.code === value) || COUNTRY_CODES[0];

  const filtered = search.trim()
    ? COUNTRY_CODES.filter(c =>
        c.name.toLowerCase().includes(search.toLowerCase()) ||
        c.code.includes(search)
      )
    : COUNTRY_CODES;

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const select = (c) => { onChange(c.code); setOpen(false); setSearch(''); };

  return (
    <div ref={ref} style={{ position: 'relative', flexShrink: 0 }}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        style={{
          display: 'flex', alignItems: 'center', gap: '6px',
          padding: '10px 10px', border: '1px solid #E5E5E0', borderRadius: '8px',
          background: 'white', cursor: 'pointer', fontFamily: "'Lexend', sans-serif",
          fontSize: '13px', whiteSpace: 'nowrap', minWidth: '100px',
        }}
      >
        <span>{selected.flag}</span>
        <span style={{ color: '#1a1a1a' }}>{selected.code}</span>
        <span style={{ color: '#999', fontSize: '10px', marginLeft: '2px' }}>▾</span>
      </button>

      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, zIndex: 200,
          background: 'white', border: '1px solid #E5E5E0', borderRadius: '10px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)', width: '260px', overflow: 'hidden',
        }}>
          <div style={{ padding: '8px' }}>
            <input
              autoFocus
              type="text"
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search country or code..."
              autoComplete="new-password"
              style={{
                width: '100%', padding: '8px 10px', border: '1px solid #E5E5E0',
                borderRadius: '6px', fontSize: '13px', fontFamily: "'Lexend', sans-serif",
                outline: 'none', boxSizing: 'border-box',
              }}
            />
          </div>
          <div style={{ maxHeight: '220px', overflowY: 'auto' }}>
            {filtered.length === 0 ? (
              <div style={{ padding: '12px', textAlign: 'center', color: '#999', fontSize: '13px' }}>No results</div>
            ) : filtered.map((c, i) => (
              <div
                key={`${c.code}-${i}`}
                onClick={() => select(c)}
                style={{
                  display: 'flex', alignItems: 'center', gap: '10px',
                  padding: '9px 12px', cursor: 'pointer', fontSize: '13px',
                  fontFamily: "'Lexend', sans-serif",
                  background: c.code === value ? '#f0f7ff' : 'transparent',
                }}
                onMouseEnter={e => e.currentTarget.style.background = '#FAFAF8'}
                onMouseLeave={e => e.currentTarget.style.background = c.code === value ? '#f0f7ff' : 'transparent'}
              >
                <span style={{ fontSize: '18px' }}>{c.flag}</span>
                <span style={{ color: '#043959', fontWeight: 600, minWidth: '42px' }}>{c.code}</span>
                <span style={{ color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.name}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

const emptyOwnerForm = {
  owner_name: '',
  owner_phone: '',
  owner_email: '',
  parking_number: '',
  intercom_no: '',
  is_rented: false,
  tenant_name: '',
  tenant_phone: '',
};

const emptyVehicleForm = {
  vehicle_number: '',
  vehicle_type: '',
};

export default function ApartmentMembersPage() {
  const [apartments, setApartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [towerFilter, setTowerFilter] = useState('all');

  // Owner edit modal
  const [showOwnerModal, setShowOwnerModal] = useState(false);
  const [editingApt, setEditingApt] = useState(null);
  const [ownerForm, setOwnerForm] = useState(emptyOwnerForm);
  const [ownerErrors, setOwnerErrors] = useState({});
  const [phoneCountryCode, setPhoneCountryCode] = useState('+91');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [submittingOwner, setSubmittingOwner] = useState(false);

  // Tenant view modal
  const [tenantViewApt, setTenantViewApt] = useState(null);

  // Tenant doc uploads
  const [aadharFile, setAadharFile] = useState(null);
  const [nocFile, setNocFile] = useState(null);
  const [uploadingDoc, setUploadingDoc] = useState(null); // 'aadhar' | 'noc'

  // Vehicle modal
  const [showVehicleModal, setShowVehicleModal] = useState(false);
  const [vehicleApt, setVehicleApt] = useState(null);
  const [vehicleForm, setVehicleForm] = useState(emptyVehicleForm);
  const [vehicleErrors, setVehicleErrors] = useState({});
  const [submittingVehicle, setSubmittingVehicle] = useState(false);

  const fetchApartments = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getApartments();
      setApartments(res.data || []);
    } catch (err) {
      console.error('Failed to load apartments', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchApartments(); }, [fetchApartments]);

  const towers = [...new Set(apartments.map((a) => a.tower))].sort();

  const filtered = apartments.filter((a) => {
    const matchesTower = towerFilter === 'all' || a.tower === towerFilter;
    const matchesSearch =
      !search ||
      a.owner_name?.toLowerCase().includes(search.toLowerCase()) ||
      a.unit?.toLowerCase().includes(search.toLowerCase()) ||
      a.owner_phone?.includes(search) ||
      a.vehicles?.some((v) => v.vehicle_number?.toLowerCase().includes(search.toLowerCase()));
    return matchesTower && matchesSearch;
  });

  // Owner edit
  const openOwnerEdit = (apt) => {
    setEditingApt(apt);
    const { countryCode, number } = splitPhone(apt.owner_phone);
    setPhoneCountryCode(countryCode);
    setPhoneNumber(number);
    setOwnerForm({
      owner_name: apt.owner_name || '',
      owner_phone: apt.owner_phone || '',
      owner_email: apt.owner_email || '',
      parking_number: apt.parking_number || '',
      intercom_no: apt.intercom_no || '',
      is_rented: !!apt.is_rented,
      tenant_name: apt.tenant_name || '',
      tenant_phone: apt.tenant_phone || '',
    });
    setOwnerErrors({});
    setAadharFile(null);
    setNocFile(null);
    setShowOwnerModal(true);
  };

  const handleOwnerChange = (e) => {
    setOwnerForm({ ...ownerForm, [e.target.name]: e.target.value });
    setOwnerErrors({ ...ownerErrors, [e.target.name]: '' });
  };

  const handleOwnerSubmit = async (e) => {
    e.preventDefault();
    setSubmittingOwner(true);
    setOwnerErrors({});
    try {
      await updateApartment(editingApt.id, ownerForm);
      // Upload docs if provided
      if (aadharFile) {
        setUploadingDoc('aadhar');
        await uploadTenantDoc(editingApt.id, 'aadhar', aadharFile);
      }
      if (nocFile) {
        setUploadingDoc('noc');
        await uploadTenantDoc(editingApt.id, 'noc', nocFile);
      }
      setShowOwnerModal(false);
      fetchApartments();
    } catch (err) {
      if (err.response?.status === 422) {
        setOwnerErrors(err.response.data.errors || {});
      } else {
        alert(err.response?.data?.message || 'Something went wrong');
      }
    } finally {
      setSubmittingOwner(false);
      setUploadingDoc(null);
    }
  };

  // Vehicle management
  const openVehicleModal = (apt) => {
    setVehicleApt(apt);
    setVehicleForm(emptyVehicleForm);
    setVehicleErrors({});
    setShowVehicleModal(true);
  };

  const handleVehicleChange = (e) => {
    setVehicleForm({ ...vehicleForm, [e.target.name]: e.target.value });
    setVehicleErrors({ ...vehicleErrors, [e.target.name]: '' });
  };

  const handleAddVehicle = async (e) => {
    e.preventDefault();
    setSubmittingVehicle(true);
    setVehicleErrors({});
    try {
      await addVehicle(vehicleApt.id, vehicleForm);
      setVehicleForm(emptyVehicleForm);
      fetchApartments();
    } catch (err) {
      if (err.response?.status === 422) {
        setVehicleErrors(err.response.data.errors || {});
      } else {
        alert(err.response?.data?.message || 'Something went wrong');
      }
    } finally {
      setSubmittingVehicle(false);
    }
  };

  const handleRemoveVehicle = async (apt, vehicleId) => {
    if (!window.confirm('Remove this vehicle?')) return;
    try {
      await removeVehicle(apt.id, vehicleId);
      fetchApartments();
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to remove vehicle');
    }
  };

  const withOwner = apartments.filter((a) => a.owner_name).length;
  const withVehicle = apartments.filter((a) => a.vehicles?.length > 0).length;
  const rented = apartments.filter((a) => a.is_rented).length;

  // Keep vehicle modal in sync after refetch
  const currentVehicleApt = vehicleApt ? apartments.find((a) => a.id === vehicleApt.id) : null;

  return (
    <AppLayout title="Apartment Members" breadcrumbs="Members">
      <div className="space-y-6">
        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
          <StatCard title="Total Apartments" value={apartments.length} icon={HiOutlineHome} color="bg-blue-100 text-blue-700" />
          <StatCard title="With Owner Info" value={withOwner} icon={HiOutlineUser} color="bg-green-100 text-green-700" />
          <StatCard title="With Vehicle" value={withVehicle} icon={HiOutlineHome} color="bg-orange-100 text-orange-700" />
          <StatCard title="Towers" value={towers.length} icon={HiOutlineHome} color="bg-purple-100 text-purple-700" />
          <StatCard title="Rented Out" value={rented} icon={HiOutlineHome} color="bg-red-100 text-red-700" />
        </div>

        {/* Filters */}
        <div className="flex flex-col sm:flex-row gap-3">
          <div className="relative flex-1">
            <HiOutlineSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
            <input
              type="text"
              placeholder="Search by owner, flat, phone or vehicle..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full pl-9 pr-4 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400"
            />
          </div>
          <div className="flex gap-2 flex-wrap">
            <button
              onClick={() => setTowerFilter('all')}
              className={`px-4 py-2 text-sm rounded-lg font-medium transition-colors ${
                towerFilter === 'all' ? 'text-white' : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-50'
              }`}
              style={towerFilter === 'all' ? { background: '#043959' } : {}}
            >
              All Towers
            </button>
            {towers.map((tower) => (
              <button
                key={tower}
                onClick={() => setTowerFilter(tower)}
                className={`px-4 py-2 text-sm rounded-lg font-medium transition-colors ${
                  towerFilter === tower ? 'text-white' : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-50'
                }`}
                style={towerFilter === tower ? { background: '#043959' } : {}}
              >
                Tower {tower}
              </button>
            ))}
          </div>
        </div>

        {/* Table */}
        {loading ? (
          <div className="text-center py-12 text-gray-500">Loading members...</div>
        ) : filtered.length === 0 ? (
          <div className="text-center py-12 text-gray-500">No members found</div>
        ) : (
          <>
            {/* Desktop Table */}
            <div className="hidden md:block bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-gray-100 bg-gray-50/50">
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase">Flat No.</th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase">Tower / Floor</th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase">Owner Name</th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase">Phone</th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase">Parking</th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase whitespace-nowrap">Intercom No.</th>
                    <th className="text-left px-6 py-3 text-xs font-medium text-gray-500 uppercase">Vehicles</th>
                    <th className="text-right px-6 py-3 text-xs font-medium text-gray-500 uppercase">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((apt) => (
                    <tr key={apt.id} className="border-b border-gray-50" style={apt.is_rented ? { background: 'rgba(254,202,202,0.5)' } : {}}>
                      <td className="px-6 py-4 text-sm font-semibold text-gray-900">{apt.unit}</td>
                      <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">Tower {apt.tower} &bull; Floor {apt.floor}</td>
                      <td className="px-6 py-4 text-sm text-gray-900">
                        <div className="flex items-center gap-2">
                          {apt.owner_name || <span className="text-gray-400 italic">Not set</span>}
                          {apt.is_rented && (
                            <span title="Rented" style={{
                              display: 'inline-flex', alignItems: 'center', gap: 3,
                              padding: '2px 7px', borderRadius: 99, fontSize: 11, fontWeight: 600,
                              background: 'rgba(239,68,68,0.1)', color: '#DC2626',
                            }}>
                              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                                <polyline points="9 22 9 12 15 12 15 22"/>
                              </svg>
                              Rented
                            </span>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">{formatPhone(apt.owner_phone) || <span className="text-gray-400">-</span>}</td>
                      <td className="px-6 py-4 text-sm text-gray-700 whitespace-nowrap">{apt.parking_number || <span className="text-gray-400">-</span>}</td>
                      <td className="px-6 py-4 text-sm text-gray-700 whitespace-nowrap" style={{ whiteSpace: 'nowrap' }}>{apt.intercom_no || <span className="text-gray-400">-</span>}</td>
                      <td className="px-6 py-4">
                        {apt.vehicles?.length > 0 ? (
                          <div className="flex flex-wrap gap-1">
                            {apt.vehicles.map((v) => (
                              <span key={v.id} className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full bg-blue-50 text-blue-700">
                                {v.vehicle_number}
                                {v.vehicle_type && <span className="text-blue-400">· {v.vehicle_type}</span>}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span className="text-gray-400 text-sm">-</span>
                        )}
                      </td>
                      <td className="px-6 py-4 text-right">
                        <div className="flex items-center justify-end gap-2">
                          {apt.is_rented && (
                            <button
                              onClick={() => setTenantViewApt(apt)}
                              className="inline-flex items-center gap-1.5 rounded-lg text-xs font-medium hover:bg-red-50 transition-colors whitespace-nowrap"
                              style={{ color: '#DC2626', padding: '5px 10px', border: '1px solid rgba(220,38,38,0.25)', background: 'rgba(220,38,38,0.05)', fontFamily: "'Lexend', sans-serif" }}
                            >
                              <HiOutlineUser className="w-3.5 h-3.5" />
                              Tenant details
                            </button>
                          )}
                          <button
                            onClick={() => openOwnerEdit(apt)}
                            className="p-1.5 rounded-lg hover:bg-gray-100 text-gray-400 hover:text-gray-600"
                          >
                            <HiOutlinePencil className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => openVehicleModal(apt)}
                            className="p-1.5 rounded-lg hover:bg-blue-50 text-gray-400 hover:text-blue-600"
                          >
                            <span className="relative inline-flex items-center">
                              <HiOutlineTruck className="w-4 h-4" />
                              <HiOutlinePlus className="w-2.5 h-2.5 absolute -top-1 -right-1.5 text-blue-500" />
                            </span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="px-6 py-3 border-t border-gray-100 bg-gray-50/30 text-xs text-gray-400">
                Showing {filtered.length} of {apartments.length} apartments
              </div>
            </div>

            {/* Mobile Cards */}
            <div className="md:hidden grid grid-cols-1 gap-4">
              {filtered.map((apt) => (
                <div key={apt.id} className="bg-white rounded-xl shadow-sm p-5 border border-gray-100">
                  <div className="flex items-start justify-between">
                    <div>
                      <h3 className="font-semibold text-gray-900">Flat {apt.unit}</h3>
                      <p className="text-xs text-gray-400 mt-0.5">Tower {apt.tower} &bull; Floor {apt.floor}</p>
                    </div>
                    <div className="flex gap-1">
                      <button onClick={() => openOwnerEdit(apt)} className="p-1.5 rounded-lg hover:bg-gray-100 text-gray-400 hover:text-gray-600">
                        <HiOutlinePencil className="w-4 h-4" />
                      </button>
                      <button onClick={() => openVehicleModal(apt)} className="p-1.5 rounded-lg hover:bg-blue-50 text-gray-400 hover:text-blue-600">
                        <span className="relative inline-flex items-center">
                          <HiOutlineTruck className="w-4 h-4" />
                          <HiOutlinePlus className="w-2.5 h-2.5 absolute -top-1 -right-1.5 text-blue-500" />
                        </span>
                      </button>
                    </div>
                  </div>
                  <div className="mt-3 space-y-1.5 text-sm">
                    <div className="flex gap-2">
                      <span className="text-gray-400 w-20 shrink-0">Owner</span>
                      <span className="text-gray-900 font-medium">{apt.owner_name || <span className="text-gray-400 italic">Not set</span>}</span>
                    </div>
                    <div className="flex gap-2">
                      <span className="text-gray-400 w-20 shrink-0">Phone</span>
                      <span className="text-gray-700">{formatPhone(apt.owner_phone) || '-'}</span>
                    </div>
                    <div className="flex gap-2">
                      <span className="text-gray-400 w-20 shrink-0">Vehicles</span>
                      <div className="flex flex-wrap gap-1">
                        {apt.vehicles?.length > 0 ? apt.vehicles.map((v) => (
                          <span key={v.id} className="inline-flex px-2 py-0.5 text-xs font-medium rounded-full bg-blue-50 text-blue-700">
                            {v.vehicle_number} {v.vehicle_type && `· ${v.vehicle_type}`}
                          </span>
                        )) : <span className="text-gray-400">-</span>}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {/* Tenant Details Modal */}
      <Modal isOpen={!!tenantViewApt} onClose={() => setTenantViewApt(null)} title="Tenant Details" size="sm">
        {tenantViewApt && (
          <div className="space-y-4">
            {/* Flat info */}
            <div className="p-3 rounded-lg text-sm" style={{ background: 'rgba(254,202,202,0.4)', color: '#7F1D1D' }}>
              Flat {tenantViewApt.unit} &bull; Tower {tenantViewApt.tower} &bull; Floor {tenantViewApt.floor}
            </div>

            {/* Tenant name & phone */}
            <div className="grid grid-cols-2 gap-3">
              <div style={{ background: '#FAFAF8', padding: '12px', borderRadius: 8 }}>
                <div className="text-xs font-medium mb-1" style={{ color: '#999' }}>Tenant Name</div>
                <div className="text-sm font-semibold" style={{ color: '#1A1A1A' }}>
                  {tenantViewApt.tenant_name || <span style={{ color: '#CCC' }}>Not set</span>}
                </div>
              </div>
              <div style={{ background: '#FAFAF8', padding: '12px', borderRadius: 8 }}>
                <div className="text-xs font-medium mb-1" style={{ color: '#999' }}>Phone</div>
                <div className="text-sm font-semibold" style={{ color: '#1A1A1A' }}>
                  {tenantViewApt.tenant_phone || <span style={{ color: '#CCC' }}>Not set</span>}
                </div>
              </div>
            </div>

            {/* Documents */}
            <div>
              <div className="text-xs font-semibold uppercase mb-2" style={{ color: '#666', letterSpacing: '0.5px' }}>Documents</div>
              <div className="flex flex-col gap-2">
                {/* Aadhaar */}
                <div className="flex items-center justify-between p-3 rounded-lg" style={{ border: '1px solid #E5E5E0', background: '#FAFAF8' }}>
                  <div className="flex items-center gap-2">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={tenantViewApt.tenant_aadhar_path ? '#DC2626' : '#CCC'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
                    </svg>
                    <span className="text-sm font-medium" style={{ color: '#1A1A1A' }}>Aadhaar</span>
                  </div>
                  {tenantViewApt.tenant_aadhar_path ? (
                    <div className="flex gap-2">
                      <a href={storageUrl(tenantViewApt.tenant_aadhar_path)} target="_blank" rel="noreferrer"
                        className="text-xs font-semibold px-3 py-1 rounded-lg"
                        style={{ background: 'rgba(220,38,38,0.08)', color: '#DC2626', textDecoration: 'none' }}>
                        View
                      </a>
                      <a href={storageUrl(tenantViewApt.tenant_aadhar_path)} download
                        className="text-xs font-semibold px-3 py-1 rounded-lg"
                        style={{ background: '#043959', color: 'white', textDecoration: 'none' }}>
                        Download
                      </a>
                    </div>
                  ) : (
                    <span className="text-xs" style={{ color: '#CCC' }}>Not uploaded</span>
                  )}
                </div>

                {/* NOC */}
                <div className="flex items-center justify-between p-3 rounded-lg" style={{ border: '1px solid #E5E5E0', background: '#FAFAF8' }}>
                  <div className="flex items-center gap-2">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={tenantViewApt.tenant_noc_path ? '#DC2626' : '#CCC'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
                    </svg>
                    <span className="text-sm font-medium" style={{ color: '#1A1A1A' }}>NOC</span>
                  </div>
                  {tenantViewApt.tenant_noc_path ? (
                    <div className="flex gap-2">
                      <a href={storageUrl(tenantViewApt.tenant_noc_path)} target="_blank" rel="noreferrer"
                        className="text-xs font-semibold px-3 py-1 rounded-lg"
                        style={{ background: 'rgba(220,38,38,0.08)', color: '#DC2626', textDecoration: 'none' }}>
                        View
                      </a>
                      <a href={storageUrl(tenantViewApt.tenant_noc_path)} download
                        className="text-xs font-semibold px-3 py-1 rounded-lg"
                        style={{ background: '#043959', color: 'white', textDecoration: 'none' }}>
                        Download
                      </a>
                    </div>
                  ) : (
                    <span className="text-xs" style={{ color: '#CCC' }}>Not uploaded</span>
                  )}
                </div>
              </div>
            </div>

            <div className="flex justify-end pt-2 border-t">
              <button
                onClick={() => { setTenantViewApt(null); openOwnerEdit(tenantViewApt); }}
                className="text-sm font-medium rounded-lg"
                style={{ padding: '8px 16px', background: '#043959', color: 'white', border: 'none', cursor: 'pointer', fontFamily: "'Lexend', sans-serif" }}
              >
                Edit Tenant Info
              </button>
            </div>
          </div>
        )}
      </Modal>

      {/* Edit Owner Modal */}
      <Modal isOpen={showOwnerModal} onClose={() => setShowOwnerModal(false)} title={`Edit Owner — Flat ${editingApt?.unit}`} size="md">
        <form onSubmit={handleOwnerSubmit} className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg text-sm text-gray-600">
            Tower {editingApt?.tower} &bull; Floor {editingApt?.floor} &bull; Unit {editingApt?.unit}
          </div>
          <FormInput
            label="Owner Name"
            name="owner_name"
            value={ownerForm.owner_name}
            onChange={handleOwnerChange}
            error={ownerErrors.owner_name?.[0]}
            placeholder="Enter owner name"
          />
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
            <div className="flex gap-2">
              <CountryCodePicker
                value={phoneCountryCode}
                onChange={(code) => {
                  setPhoneCountryCode(code);
                  setOwnerForm({ ...ownerForm, owner_phone: `${code}${phoneNumber}` });
                }}
              />
              <input
                type="tel"
                value={phoneNumber}
                onChange={(e) => {
                  setPhoneNumber(e.target.value);
                  setOwnerForm({ ...ownerForm, owner_phone: `${phoneCountryCode}${e.target.value}` });
                  setOwnerErrors({ ...ownerErrors, owner_phone: '' });
                }}
                placeholder="Enter phone number"
                autoComplete="new-password"
                className="flex-1"
                style={{
                  padding: '10px 12px', border: '1px solid #E5E5E0', borderRadius: '8px',
                  fontSize: '14px', fontFamily: "'Lexend', sans-serif", outline: 'none',
                }}
              />
            </div>
            {ownerErrors.owner_phone?.[0] && (
              <p className="text-xs text-red-500 mt-1">{ownerErrors.owner_phone[0]}</p>
            )}
          </div>
          <FormInput
            label="Email"
            name="owner_email"
            type="email"
            value={ownerForm.owner_email}
            onChange={handleOwnerChange}
            error={ownerErrors.owner_email?.[0]}
            placeholder="Enter email address"
          />
          <FormInput
            label="Parking Number"
            name="parking_number"
            value={ownerForm.parking_number}
            onChange={handleOwnerChange}
            error={ownerErrors.parking_number?.[0]}
            placeholder="e.g. P1-101"
          />
          <FormInput
            label="Intercom No."
            name="intercom_no"
            value={ownerForm.intercom_no}
            onChange={handleOwnerChange}
            error={ownerErrors.intercom_no?.[0]}
            placeholder="e.g. 201"
          />
          <div
            onClick={() => setOwnerForm({ ...ownerForm, is_rented: !ownerForm.is_rented })}
            className="flex items-center justify-between cursor-pointer rounded-lg"
            style={{ padding: '12px 14px', border: '1px solid', borderColor: ownerForm.is_rented ? '#10B981' : '#E5E5E0', background: ownerForm.is_rented ? 'rgba(16,185,129,0.06)' : '#FAFAF8', userSelect: 'none' }}
          >
            <div className="flex items-center gap-3">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={ownerForm.is_rented ? '#10B981' : '#999'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
              <div>
                <div className="text-sm font-medium" style={{ color: '#1A1A1A' }}>Rented Out</div>
                <div className="text-xs" style={{ color: '#999' }}>This apartment is currently rented to a tenant</div>
              </div>
            </div>
            <div style={{
              width: 40, height: 22, borderRadius: 99, transition: 'background 0.2s',
              background: ownerForm.is_rented ? '#10B981' : '#D0D0CC',
              position: 'relative', flexShrink: 0,
            }}>
              <div style={{
                position: 'absolute', top: 3, width: 16, height: 16, borderRadius: '50%', background: 'white',
                transition: 'left 0.2s', left: ownerForm.is_rented ? 21 : 3,
                boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
              }} />
            </div>
          </div>
          {/* Tenant details — visible only when rented */}
          {ownerForm.is_rented && (
            <div style={{ borderTop: '1px solid #F0F0EB', paddingTop: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div className="text-xs font-semibold uppercase" style={{ color: '#DC2626', letterSpacing: '0.5px' }}>Tenant Details</div>
              <FormInput
                label="Tenant Name"
                name="tenant_name"
                value={ownerForm.tenant_name}
                onChange={handleOwnerChange}
                placeholder="Enter tenant name"
              />
              <FormInput
                label="Tenant Phone"
                name="tenant_phone"
                value={ownerForm.tenant_phone}
                onChange={handleOwnerChange}
                placeholder="Enter tenant phone"
              />

              {/* Doc uploads */}
              <div className="grid grid-cols-2 gap-3">
                {/* Aadhaar */}
                <div>
                  <label className="block text-sm font-medium mb-1" style={{ color: '#1A1A1A' }}>Aadhaar</label>
                  <label style={{
                    display: 'flex', alignItems: 'center', gap: 8, padding: '10px 12px',
                    border: '1px dashed', borderColor: aadharFile ? '#DC2626' : '#E5E5E0',
                    borderRadius: 8, background: '#FAFAF8', cursor: 'pointer',
                  }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={aadharFile ? '#DC2626' : '#999'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/>
                    </svg>
                    <span className="text-xs truncate" style={{ color: aadharFile ? '#1A1A1A' : '#999' }}>
                      {aadharFile ? aadharFile.name : (editingApt?.tenant_aadhar_path ? '✓ Uploaded' : 'Choose file')}
                    </span>
                    <input type="file" accept="image/*,.pdf" style={{ display: 'none' }} onChange={e => setAadharFile(e.target.files[0] || null)} />
                  </label>
                </div>
                {/* NOC */}
                <div>
                  <label className="block text-sm font-medium mb-1" style={{ color: '#1A1A1A' }}>NOC</label>
                  <label style={{
                    display: 'flex', alignItems: 'center', gap: 8, padding: '10px 12px',
                    border: '1px dashed', borderColor: nocFile ? '#DC2626' : '#E5E5E0',
                    borderRadius: 8, background: '#FAFAF8', cursor: 'pointer',
                  }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={nocFile ? '#DC2626' : '#999'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/>
                    </svg>
                    <span className="text-xs truncate" style={{ color: nocFile ? '#1A1A1A' : '#999' }}>
                      {nocFile ? nocFile.name : (editingApt?.tenant_noc_path ? '✓ Uploaded' : 'Choose file')}
                    </span>
                    <input type="file" accept="image/*,.pdf" style={{ display: 'none' }} onChange={e => setNocFile(e.target.files[0] || null)} />
                  </label>
                </div>
              </div>
              {uploadingDoc && (
                <p className="text-xs" style={{ color: '#999' }}>Uploading {uploadingDoc}…</p>
              )}
            </div>
          )}

          <div className="flex justify-end gap-3 pt-4 border-t">
            <Button variant="secondary" type="button" onClick={() => setShowOwnerModal(false)}>Cancel</Button>
            <Button type="submit" loading={submittingOwner}>Save Changes</Button>
          </div>
        </form>
      </Modal>

      {/* Manage Vehicles Modal */}
      <Modal isOpen={showVehicleModal} onClose={() => setShowVehicleModal(false)} title={`Vehicles — Flat ${vehicleApt?.unit}`} size="md">
        <div className="space-y-5">
          {/* Existing vehicles */}
          <div>
            <h4 className="text-sm font-medium text-gray-700 mb-2">Registered Vehicles</h4>
            {currentVehicleApt?.vehicles?.length > 0 ? (
              <div className="space-y-2">
                {currentVehicleApt.vehicles.map((v) => (
                  <div key={v.id} className="flex items-center justify-between px-3 py-2.5 bg-gray-50 rounded-lg">
                    <div>
                      <span className="text-sm font-semibold text-gray-900">{v.vehicle_number}</span>
                      {v.vehicle_type && (
                        <span className="ml-2 text-xs text-gray-500 bg-white border border-gray-200 px-2 py-0.5 rounded-full">{v.vehicle_type}</span>
                      )}
                    </div>
                    <button
                      onClick={() => handleRemoveVehicle(currentVehicleApt, v.id)}
                      className="p-1.5 rounded-lg hover:bg-red-50 text-gray-400 hover:text-red-500"
                    >
                      <HiOutlineTrash className="w-4 h-4" />
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-sm text-gray-400 italic">No vehicles registered yet.</p>
            )}
          </div>

          {/* Add new vehicle */}
          <div className="border-t pt-4">
            <h4 className="text-sm font-medium text-gray-700 mb-3">Add New Vehicle</h4>
            <form onSubmit={handleAddVehicle} className="space-y-3">
              <FormInput
                label="Vehicle Number"
                name="vehicle_number"
                value={vehicleForm.vehicle_number}
                onChange={handleVehicleChange}
                error={vehicleErrors.vehicle_number?.[0]}
                placeholder="e.g. TN01AB1234"
              />
              <FormSelect
                label="Vehicle Type"
                name="vehicle_type"
                value={vehicleForm.vehicle_type}
                onChange={handleVehicleChange}
                options={vehicleTypeOptions}
                error={vehicleErrors.vehicle_type?.[0]}
              />
              <Button type="submit" loading={submittingVehicle} className="w-full">
                Add Vehicle
              </Button>
            </form>
          </div>

          <div className="flex justify-end pt-2 border-t">
            <Button variant="secondary" type="button" onClick={() => setShowVehicleModal(false)}>Close</Button>
          </div>
        </div>
      </Modal>
    </AppLayout>
  );
}
